export default {
    public: {
        doc: '文档',
        yes: '是',
        no: '否',
        param: '参数',
        noData: '暂无数据',
        dataType: '数据类型',
        describe: '描述',
        require: '必选',
        debug: '调试',
        debugResult: '调试结果',
        pleaseSelect: '请选择',
        downLoad: '下载',
        template: '模板',
        downLoadTemplate: '下载模板',
        publicRequestParam: '公共请求参数',
        workRequestParam: '业务请求参数',
        requestExample: '请求示例',
        example: '示例',
        example1: '例如',
        respondParam: '返回参数',
        respondCode: '返回码',
        respondExample: '返回示例',
        callBackRespondExample: 'callBack返回示例',
        defaultValue: '默认值',
        copySuccess: '复制成功'
    },
    home: {
        debugApi: 'API在线调试',
        searchWord: '请输入中/英关键词搜索API',
        seeRequireItem: '只看必填项',
        fillDefaultValue: '填写默认值',
        debugTip1: '发起调试时获取，使用描述见文档',
        debugTip2: '发起调试时获取，使用描述见文档',
        debugTip3: '调试页面一次最多支持写入10个变量',
        uploadTip1: '检测到文件已变更，请上传最新文件！',
        pleaseSelectFile: '请选择文件',
        clickChangeId: '点击切换deviceId或serialNo',
        clickChangeName: '点击切换deviceName或serialNo',
        clickChangeIot: '点击切换iotName或regCode',
        clickChangeTemplateNameOrId: '点击切换templateName或id',
        canSelectMore: '可以输入多个queryData值以逗号隔开,例如:xx,xx,xx...',
        supportSlsx: '上传文件后缀只能是 xlsx!',
        errorFileFormat: '字段输入格式不符'
    },
    file: {
        apiIntroduce: '接口说明',
        apiName: 'API 接口名称',
        apiProtocol: 'API 协议版本',
        clickEnter: '点击进入',
        describe1: '云平台分配给应用的 AppKey ',
        describe2: '时间戳，格式为yyyy-MM-dd HH:mm:ss，时区为GMT+8， 例如：2015-01-01 12:00:00。API 服务端允许客户端请求3分钟内有效 ',
        describe3: 'API 输入参数签名结果，签名算法介绍'
    },
    debug: {
        noDebugResult: '暂无调试结果',
        debugTip1: '发起调试后，您可在此获取调试结果、真实请求URL、响应头和响应体信息',
        beginDebug: '发起调试',
        overView: '概览',
        debugSuccess: '调试成功',
        debugFailed: '调试失败',
        consumeTime: '耗时',
        statusCode: '状态码',
        requestType: '请求方式',
        realRequestUrl: '真实请求URL',
        requestData: '请求数据',
        requestHeader: '请求头',
        requestData: '请求体',
        respondResult: '响应结果',
        respondHeader: '响应头',
        respondBody: '响应体'
    }
}